import { render, staticRenderFns } from "./UploadMessageModal.vue?vue&type=template&id=23fb85d8"
import script from "./UploadMessageModal.vue?vue&type=script&lang=js"
export * from "./UploadMessageModal.vue?vue&type=script&lang=js"
import style0 from "./UploadMessageModal.vue?vue&type=style&index=0&id=23fb85d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports